"use client";
import styled from "styled-components";
import ThemeContainer from "@/components/common/theme/container";
import Title from "@/components/common/ui/Title";
import reactHtmlParser from "react-html-parser";

const AllAbout = ({data}) => {


    return (
        <StyledComponent>
            <ThemeContainer colProps={{md: 9}}>
                <Title width={'100%'} text={'Privacy Policy'} border type={'h4'} margin={'0 0 60px'}/>
                {
                    reactHtmlParser(data?.section_data?.description)
                }
            </ThemeContainer>
        </StyledComponent>
    );
};


const StyledComponent = styled.section`
    padding: 180px 0;
    background: #F8F6F5;    
    h3, h5, h6, h2 {
        margin-bottom: 20px;
    }

    p, .list-count {
        margin-bottom: 60px;
    }
    
    .title{
        padding-bottom: 20px;
    }
`;

export default AllAbout;
